import { Injectable } from '@angular/core';
import {
  HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';

import { AuthService } from '../core-services/auth.service';
import eventEmitter from '../core-services/eventEmitter';


@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  currentUser: any;
  constructor(private auth: AuthService, private router: Router, private toastr: ToastrService, private spinner: NgxSpinnerService) { }

  intercept(
    // tslint:disable-next-line:no-any
    req: HttpRequest<any>,
    next: HttpHandler
    // tslint:disable-next-line:no-any
  ): Observable<HttpEvent<any>> {
    if (req.body) {
      req.headers.append('Content-Type', 'application/json');
      req.headers.append('If-Modified-Since', 'Mon, 26 Jul 1997 05:00:00 GMT');
      req.headers.append('Cache-Control', 'no-cache');
      req.headers.append('Pragma', 'no-cache');
    }
    this.currentUser = this.auth.currentUserValue;
    const token = this.currentUser != null ? this.currentUser.accessToken : null // localStorage.getItem('access_token') ? localStorage.getItem('access_token') : null;
    if (token != null) {
      req = req.clone({
        headers: req.headers
          .set('Authorization', 'Bearer ' + token)
        // setHeaders: {
        //   Authorization: 'Bearer ' + token
        // }
      });
    }

    return next.handle(req).pipe(
      tap(
        (event: HttpEvent<any>) => {
          if (event instanceof HttpResponse) {
          }
        },
        (err: any) => {
          this.spinner.hide();
          if (err instanceof HttpErrorResponse) {
            if(err != null)
            {
              if(err.status == 401)
              {
                this.auth.logout();
                this.spinner.hide();
                // this.router.navigate(['/login']);
                this.toastr.info('Token expired', 'Info')
                eventEmitter.emit('openLoginModal');
              }
            }
          }
        }
      )
    );
  }
}
